import React from 'react'

const HeadingOfSection = (props) => {
  return (
    <div className='flex flex-col gap-6 lg:gap-8 xxl:gap-10 items-center justify-center w-full pt-8 md:pt-16 z-[100]'>
        <h1 className='my-0 text-[25px] xs:text-[30px] md:text-[37px] lg:text-[40px] xl:text-[45px] xxxl:text-[50px] text-primary02 font-bold text-center w-[90%] md:w-full'>{props.header}<span className='text-primary relative after:absolute after:content-[""] after:w-full after:h-2 after:bg-secondary after:left-0 after:bottom-[6px] after:z-[-1]'>{props.span}</span></h1>
        <p className=' w-[90%] md:w-[85%] lg:w-3/4 text-center text-[15px] xs:text-[17px] sm:text-[20px] md:text-[25px] lg:text-[25px] xl:text-[28px] xxxl:text-[32px] text-primary02'>{props.text}</p>
    </div>
  )
}

export default HeadingOfSection